import React from 'react';
import Careers from '../components/Careers/Careers';
import './CareersPage.css';

const CareersPage = () => {
  return (
    <div className="careers-page">
      <div className="careers-page-hero">
        <div className="container">
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span className="separator">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 3l5 5-5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
            <span>Careers</span>
          </div>
          <h1>Build Your Career With Us</h1>
          <p>Join our team of innovators and shape the future of technology</p>
        </div>
      </div>
      <Careers />
    </div>
  );
};

export default CareersPage;
